import { MessageCircleWarning } from 'lucide-react';
import { PhaseStubPage } from '@/components/layout/PhaseStubPage';

export function ComplaintsPage() {
  return (
    <PhaseStubPage
      title="Complaints"
      phase={6}
      modules={[
        'Private complaint intake (subject, category, narrative)',
        'Optional anonymity where policy allows',
        'Routing that skips the named subject (e.g. skip the manager being complained about)',
        'Status tracking for the filer without exposing investigator notes',
        'Admin / designated HR reviewer queue with audit trail',
      ]}
      icon={MessageCircleWarning}
    />
  );
}
